import {
  Component, Vue, Watch, Mixins, Ref,
} from 'vue-property-decorator';


@Component({
  name: 'App',
  components: {
    // 'file-column': require('@/components/FileColumn.vue').default,
  },
})
export default class App extends Vue {
  name = 'App'

  menu = [
    // {
    //   route: {name: 'home'},
    //   title: 'Home',
    //   icon: 'mdi-home'
    // },
    {
      route: { name: 'drop' },
      title: 'Drop',
      icon: 'mdi-folder-upload',
    },
    {
      route: { name: 'calendars' },
      title: 'Calendars',
      icon: 'mdi-calendar',
    },
    {
      route: { name: 'supercruiser-raw' },
      title: 'Supercruiser raw',
      icon: 'mdi-folder-upload',
    },
    // {
    //   route: {name: 'profile'},
    //   title: 'Profile',
    //   icon: 'mdi-account'
    // },
  ]

  drawer = false;

  get user() {
    if (!this.$auth || !this.$auth.state.uid) {
      return null;
    }
    return this.$store.state.users.all[this.$auth.state.uid];
  }

  signOut() {
    this.$auth.signOut();
  }
}
